const INITIAL_STATE = {
  uid: null,
  jobTitle: null,
  jobDescription: null,
  jobFormat: 'remote',
  jobLocation: null,
  companyTitle: null,
  contactEmail: null,
  imageId: null,
  imageUrl: null,
  authorName: null,
  authorAvatarUrl: null,
  authorCpd: null,
  authorOrganization: null,
  authorJob: null,
  authorVisible: false,
  authorEnglishName: null,
}

export default function readDraft(currentState = window.vacancyDraft) {
  return Object.assign({}, INITIAL_STATE, currentState)
}
